import React from "react";


export default ({href, caption, onClick, style}) =>
    <a
        href={href} className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
        onClick={onClick}
        style={style}
    >
        {caption}
    </a>
